export const RequestType = Object.freeze({
    BUG_REPORT: 'BUG_REPORT',
    FEATURE_REQUEST: 'FEATURE_REQUEST'
});
